import { SentryConfig } from "@mezo/sdk"
import {
  BrowserOptions,
  browserTracingIntegration,
  init as sentryInit,
  replayIntegration,
} from "@sentry/react"

import { SENTRY_DSN, SENTRY_ENV } from "#/shared/constants"

import { useEffectOnce } from "./custom"

const SENTRY_ENVIRONMENTS = {
  production: "production",
  staging: "staging",
  local: "local",
}

const sentryEnvironment =
  SENTRY_ENVIRONMENTS[SENTRY_ENV as keyof typeof SENTRY_ENVIRONMENTS]

// These errors are coming from external package
const WALLET_CONNECT_ERRORS: RegExp[] = [
  /To use QR modal, please install @walletconnect\/modal package/gim,
  /Socket stalled when trying to connect to wss:\/\/relay.walletconnect.org/gim,
  /WebSocket connection failed for host: wss:\/\/relay.walletconnect.org/gim,
]

const SENTRY_IGNORED_ERRORS: RegExp[] = [
  // error caused by network change in the wallet
  /underlying network changed/gim,
  // not something we should care about
  /No internet connection detected/gim,
  // caused by wallet, nothing we can do on our side
  /Object captured as promise rejection with keys/gim,
  ...WALLET_CONNECT_ERRORS,
]

const SENTRY_OPTIONS: BrowserOptions = {
  dsn: SENTRY_DSN,
  environment: sentryEnvironment,
  integrations: [browserTracingIntegration(), replayIntegration()],
  ignoreErrors: SENTRY_IGNORED_ERRORS,
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  maxValueLength: 1000, // to avoid error message being trimmed
}

export const sentryConfig: SentryConfig = {
  sentryDsn: SENTRY_DSN,
  sentryEnv: sentryEnvironment,
  sentryOptions: SENTRY_OPTIONS,
}

const useSentry = () => {
  useEffectOnce(() => {
    if (SENTRY_DSN && SENTRY_ENV && sentryEnvironment) {
      sentryInit(SENTRY_OPTIONS)
    }
  })
}

export default useSentry
